import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPersistedState from "pinia-plugin-persistedstate";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";
import { createAuth0 } from "@auth0/auth0-vue";
import { definePreset } from "@primevue/themes";
import Aura from "@primevue/themes/aura";

import router from "./router";
import App from "./App.vue";

import { neena } from "@/assets/neenaColors.js";

import "@/assets/styles.scss";
import "@/assets/tailwind.css";

const neenaPreset = definePreset(Aura, {
  primitive: {
    neena: neena,
  },
  semantic: {
    primary: {
      50: "{neena.red.50}",
      100: "{neena.red.100}",
      200: "{neena.red.200}",
      300: "{neena.red.300}",
      400: "{neena.red.400}",
      500: "{neena.red.400}",
      600: "{neena.red.600}",
      700: "{neena.red.700}",
      800: "{neena.red.800}",
      900: "{neena.red.900}",
      950: "{neena.red.950}",
    },
    colorScheme: {
      light: {
        surface: {
          0: "#ffffff",
          50: "{stone.50}",
          100: "{stone.100}",
          200: "{stone.200}",
          300: "{stone.300}",
          400: "{stone.400}",
          500: "{stone.500}",
          600: "{stone.600}",
          700: "{stone.700}",
          800: "{stone.800}",
          900: "{stone.900}",
          950: "{stone.950}",
        },
        text: {
          color: "{neena.darkgreen.500}",
        },
      },
      dark: {},
    },
  },
});

const auth0 = createAuth0({
  domain: import.meta.env.VITE_APP_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window.location.origin + "/login-handler",
    audience: import.meta.env.VITE_APP_AUTH0_AUDIENCE,
  },
});

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPersistedState);

app.use(auth0);
app.use(pinia);
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: neenaPreset,
    options: {
      darkModeSelector: ".app-dark",
    },
  },
});

app.use(ToastService);
app.use(ConfirmationService);

app.mount("#app");
